import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '../../routes/path';
import { LockClosedIcon } from '@heroicons/react/24/outline';

const AccessDenied = () => {
  return (
    <div className="w-full h-full min-h-[60vh] flex flex-col items-center justify-center p-8 text-center bg-white dark:bg-[#0f172a] rounded-3xl border border-gray-100 dark:border-gray-800 transition-colors">
      <div className="bg-red-50 dark:bg-red-900/20 p-6 rounded-full mb-6">
        <LockClosedIcon className="w-16 h-16 text-[#dc343b] dark:text-red-400" />
      </div>
      <h1 className="text-3xl font-extrabold text-gray-900 dark:text-white tracking-tight mb-3">
        Access Denied
      </h1>
      <p className="text-gray-500 dark:text-gray-400 max-w-md mb-8">
        You do not have permission to view this page. If you believe this is a mistake, please contact the business owner to update your staff permissions.
      </p>
      <Link 
        to={PATHS.DASHBOARD}
        className="bg-[#dc343b] text-white px-8 py-3 rounded-xl font-bold hover:bg-[#b91c1c] transition-colors shadow-sm shadow-red-500/20"
      >
        Go to Dashboard
      </Link>
    </div>
  );
};

export default AccessDenied;
